import { useStore } from "@nanostores/react"

import { useEvent } from "shared/lib/useEvent"

import { ProductFilterFormData } from "entities/products/types/ProductFilter"

import {
  portfolioFilterStore,
  resetFilterState,
  setFilterState,
  updateFilterState
} from "./portfolio-filter-store"

export function usePortfolioFilterStore() {
  const state = useStore(portfolioFilterStore)

  const setFilters = useEvent((newState: ProductFilterFormData) => {
    setFilterState(newState)
  })

  const updateFilters = useEvent((updates: Partial<ProductFilterFormData>) => {
    updateFilterState(updates)
  })

  const resetFilters = useEvent(() => {
    resetFilterState()
  })

  return {
    filterState: state,
    setFilters,
    updateFilters,
    resetFilters
  }
}
